import { BaseModel } from "./BaseModel";
import { CalculationHelper, CalculationModel } from "./CalculationHelper";
import { CalcualtionResultKeys, TabNames } from '../modules/Constants';

export class SaleableSqueezeModel extends BaseModel {
    overrideFormatSheet() {
        let result = {}
        result.rows = [];

        let emptyCell = {
            backgroundColor: '#f9f9f9',
            verticalAlign: 'middle',
        }

        let squeezeTotalString = ""
        //-- add summary row
        result.rows.push({
            cells: [
                { value: "Net Squeeze", wrap: true, style: this.defaultHeader() },
                { formula: squeezeTotalString, wrap: true, style: this.defaultCell(), format: '#,##0.00' }
            ]
        });
        result.rows.push({ cells: [] });

        let tableStartingColumn = 0;
        let tableStartingRow = 2;

        this.Display.SaleablePart.forEach(table => {

           table.forEach((row, rowIndex) => {
               let rowData = {}
               let startingColumn = tableStartingColumn;

               rowData.cells = row.map((column, columnIndex) => {
                   let cell = {};

                   cell.style = this.defaultCell();
                   cell.wrap = true;
                   cell.value = column;

                   if (cell.value === null) {
                       cell.style = emptyCell;
                   }

                   if (columnIndex > 0 && rowIndex >= 2) {
                       cell.format = '#,##0.00';
                   }

                   if ((columnIndex == 0 && cell.value != null) || (rowIndex < 2)) {
                       cell.style = this.defaultHeader();
                       cell.format = null;
                   }

                   let helper = new BaseModel();
                   if (columnIndex == 6 && rowIndex >= 2 && cell.value != null && cell.value == "") {
                       let volumeColumn = helper.excelLetter(startingColumn + 2);
                       let materialColumn = helper.excelLetter(startingColumn + 6);
                       cell.formula = `=(${materialColumn}${rowIndex + tableStartingRow} - ${materialColumn}${rowIndex + 1 + tableStartingRow}) * ${volumeColumn}${rowIndex + 1 + tableStartingRow}`;
                   }
                   else if (columnIndex == 4 && rowIndex >= 2 && cell.value != null && cell.value == "") {
                       let volumeColumn = helper.excelLetter(startingColumn + 2);
                       let opsColumn = helper.excelLetter(startingColumn + 3);
                       cell.formula = `=(${opsColumn}${rowIndex + 1 + tableStartingRow} - ${opsColumn}${rowIndex + tableStartingRow} ) * ${volumeColumn}${rowIndex + 1 + tableStartingRow}`;
                   }
                   else if (rowIndex >= 2 && cell.value != null && cell.value == "=Sum") {
                       cell.value = null;
                       let columnLetter = helper.excelLetter((columnIndex + 1) + startingColumn);
                       cell.formula = `=SUM(${columnLetter}${tableStartingRow + 3}:${columnLetter}${rowIndex + tableStartingRow})`;

                       if (squeezeTotalString == "") {
                           squeezeTotalString += `= ${columnLetter}${rowIndex + 1 + tableStartingRow}`
                       } else {
                           squeezeTotalString += `+ ${columnLetter}${rowIndex + 1 + tableStartingRow}`
                       }
                   }


                   return cell;
               });

               if (result.rows[rowIndex + tableStartingRow]) {
                   var exisitingRow = result.rows[rowIndex + tableStartingRow];
                   exisitingRow.cells.push({});
                   exisitingRow.cells.push.apply(exisitingRow.cells, rowData.cells);

               } else {
                   var cells = Array(startingColumn).fill({})
                   cells.push.apply(cells, rowData.cells);
                   rowData.cells = cells;
                   result.rows.push(rowData);
               }
           });

            tableStartingColumn += 8
        });

        //update summary row
        result.rows[0].cells[1].formula = squeezeTotalString;
        result.columns = Array(Math.max(...result.rows.map(i => i.cells.length))).fill({ width: 150 }); 

        return result
    }

    constructor() {
        super();
        this.TabName = TabNames.MATERIAL_SQUEEZE;
        this.TabIndex = 2;
        this.DataProcessor = new SaleableSqueezeProcessor();
        this.formatSheet = this.overrideFormatSheet;
    }
}

export class SaleableSqueezeProcessor {

    process(data) {
        let Calculations = [];
        let Calcs = data.calculations_parsed[1];
        let ExchangeRates = [];
        let Volumes = [];
        let Records = [];
        let Currency = data.currency;
        let Years = [];

        let study = data.study;
        let snapshots = data.snapshots;
        let version = data.version;

        study.exchangeRates.forEach(rate => {
            rate.Item2.Values.forEach(item => {
                ExchangeRates.push({
                    currency: rate.Item1,
                    year: new Date(item.Date).getUTCFullYear(),
                    value: item.Value
                });
            });
        });

        Calcs.forEach(calc => {
            Calculations.push(new CalculationModel(calc.calculationText, calc.calculation, calc.val, calc.amount, ExchangeRates, Currency))
        })

        snapshots.forEach(snapshot => {
            snapshot.SaleableParts.forEach(part => {
                let key = new CalculationHelper().getPartKey(part);
                Volumes[key] = { first: 0, total: 0, years: [] };

                var firstYearIndex = part.CostStudyVolume.Value.Fields[0].Values.findIndex(x => x.Value > 0)
                if (!firstYearIndex || firstYearIndex == -1) {
                    firstYearIndex = 0
                }
                let firstYear = part.CostStudyVolume.Value.Fields[0].Values[firstYearIndex];
                Volumes[key].first = firstYear.Value;


                part.CostStudyVolume.Value.Fields.forEach(volume => {
                    volume.Values.forEach(value => {
                        Volumes[key].total += value.Value;
                        var year = new Date(value.Date).getUTCFullYear();
                        Volumes[key].years[year] = (Volumes[key].years[year] ?? 0) + value.Value;
                    });
                });
            });

        });

        let firstSOPYear = Math.min.apply(Math, snapshots.map(snapshot => snapshot.SaleableParts?.map(part => new Date(part?.CustomerSOP?.Value.Fields[0]).getUTCFullYear())).reduce(function (a, b) { return a.concat(b) }, []));
        let firstYearSpend = firstSOPYear - (version?.SpendYearsPriorToSOP?.Value?.Fields[0] ?? 2);
        let lastYearSpend = firstSOPYear + (version?.SpendYearsAfterSOP?.Value?.Fields[0] ?? 0);
        snapshots.forEach(snapshot => {
            snapshot.SaleableParts.forEach(part => {
                let endDate = part.CustomerVolume?.Value?.Fields[0]?.EndDate;
                if (endDate) {
                    let year = new Date(endDate).getUTCFullYear();
                    if (year > lastYearSpend) {
                        lastYearSpend = year;
                    }
                }
            });
        })

        snapshots.forEach(snapshot => {
            snapshot.SaleableParts.forEach(part => {
                let endDate = part.CustomerVolume?.Value?.Fields[0]?.EndDate;
                if (endDate) {
                    let year = new Date(endDate).getUTCFullYear();
                    if (year > lastYearSpend) {
                        lastYearSpend = year;
                    }
                }
            });
        })

        var yearsSpending = Array.from(Array((lastYearSpend - firstYearSpend) + 1), (_, x) => x + firstYearSpend);
        Years = yearsSpending;
        Years.sort();

        snapshots.forEach(snapshot => {
            snapshot.SaleableParts.forEach(part => {
                var model = new SaleableSqueezePartModel(version, snapshot, part, Calculations, Volumes, Years);
                Records.push(model);
            })
        })

        let result = {
            headers: [],
            display: this.getDisplay(Years, Records),
            numerics: []
        };

        return result;
    }



    getDisplay(Years, Records) {

        let display = {};
        display.SaleablePart = [];
        Records.forEach((record) => {

            var table = this.getSaleablePartTable(Years, record);
            display.SaleablePart.push(table);
     

        });

        return display;
    }

    getSaleablePartTable(Years, Record) {
        var result = [
            ["Saleable Part Number", Record.SaleablePartNumber, "Saleable Part Rev", Record.SaleablePartRev, "Saleable Part Suffix", Record.SaleablePartSuffix, ""],
            ["Year", "Volume", "Outside Product Sales", " APR | NCP $'s ", "Sales Pricing $Value", "Mat'l Cost", "Mat'l Perf"],
        ]

        Years.forEach((year, index) => {
            let displayMatlPerformance = Record.MaterialCost[index - 1] > 0 && Record.MaterialCost[index] > 0
            let displaySalesPricing = Record.OutsideProductSales[index - 1] > 0 && Record.OutsideProductSales[index] > 0
            let arr = [year, Record.Volume[index], Record.OutsideProductSales[index], null, displaySalesPricing ? "" : null, Record.MaterialCost[index], displayMatlPerformance ? "" : null];
            result.push(arr);
        })

        result.push(["Total", null, null, null, "=Sum", null, "=Sum"]);
        result.push(["", "", "", "", "(unfavorable)", "", "(favorable)"]);

 
        return result;
    }
}

export class SaleableSqueezePartModel {
    CostStudy = "";
    Version = "";
    OptionName = "";
    SaleablePartNumber = "";
    SaleablePartRev = "";
    SaleablePartSuffix = "";
    CustomerSaleablePartNumber = "";
    Volume = [];
    OutsideProductSales = [];
    MaterialCost = [];
    

    constructor(version, snapshot, part, calculations, volumes, years) {

        let calculationHelper = new CalculationHelper();
        let partKey = calculationHelper.getPartKey(part);
        this.CostStudy = version.ECRNumber.Value.Fields[0];
        this.Version = version.Name;
        this.OptionName = snapshot?.GroupName;
        this.SaleablePartNumber = part.Part?.Number?.Fields[0] ?? "";
        this.SaleablePartRev = part.Part?.DrawingRevision?.Fields[0]?.Fields[0] ?? "";
        this.SaleablePartSuffix = part.Part?.Suffix?.Fields[0]?.Fields[0] ?? "";
        this.CustomerSaleablePartNumber = "";

        let partData = calculations.filter(item => { return item.partNumber === this.SaleablePartNumber && item.partRev === this.SaleablePartRev && item.partSuffix === this.SaleablePartSuffix && item.groupName === this.OptionName; })

        //-- Material Percent
        let inboundFreightCalcs = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_FREIGHT }]);
        let inboundDutyCalcs = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_DUTY }]);
        let materialFreightAndDutyCalcs = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL_AND_FREIGHT_DUTY }]);
        let outsideProductSalesCalcs = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.OUTSIDE_PRODUCT_SALES }]);
        let materialCalcs = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL }]);


        years.forEach(year => {
            let material = 0;
            let outsideProductSales = outsideProductSalesCalcs[year];
            let volume = volumes[partKey].years[year];


            if (calculationHelper.hasNewMaterialBucket(partData)) {
                material = materialCalcs[year];
            }
            else {
                let inboundFreight = inboundFreightCalcs[year];
                let inboundDuty = inboundDutyCalcs[year];
                let materialFreightAndDuty = materialFreightAndDutyCalcs[year];
                let freightAndDuty = inboundFreight + inboundDuty;
                material = materialFreightAndDuty - freightAndDuty;
            }


            let outsideProductSalesPerPc = calculationHelper.getNumber(outsideProductSales / volume);
            let materialPerPc = calculationHelper.getNumber(material / volume);
            let volumeK = calculationHelper.getNumber(volume / 1000);

            this.Volume.push(volumeK > 0 ? volumeK : null);
            this.OutsideProductSales.push(outsideProductSalesPerPc > 0 ? outsideProductSalesPerPc : null);
            this.MaterialCost.push(materialPerPc > 0 ? materialPerPc : null);
            
        })
        
    }

}